<template>
<div v-if="store.loading" class="rn-testimonial-area-notin rn-section-gap py-10">
    <v-container>
        <v-card class="elevation-0 bg-transparent text-center">
            <v-skeleton-loader
                type="paragraph"
                :color="style.ThemeGeneral?.TextoCss?.Color ? style.ThemeGeneral.TextoCss.Color + '10' : 'rgba(0,0,0,0.05)'"
                class="mb-6 mx-auto"
                max-width="600"
            ></v-skeleton-loader>
            <div class="d-flex justify-center mt-10" style="gap: 20px;">
                <v-skeleton-loader
                    v-for="n in 5"
                    :key="'avatar-skel-' + n"
                    type="avatar"
                    :color="style.ThemeGeneral?.TextoCss?.Color ? style.ThemeGeneral.TextoCss.Color + '10' : 'rgba(0,0,0,0.05)'"
                ></v-skeleton-loader>
            </div>
        </v-card>
    </v-container>
</div>

<div class="rn-testimonial-area-notin rn-section-gap" id="testimonial"
  v-if="!store.loading && NOTARIA && NOTARIA.Theme && NOTARIA.Theme.Home.Testimonios.Mostrar && NOTARIA.Testimonios?.length > 0">
    <v-container>
        <v-row>
            <v-col cols="12">
            <!-- Start Tab Content  -->
            <div class="rn-testimonial-content-notin testimonial-notin">
                <client-only>
                    <v-window v-model="tab" role="tablist" aria-busy="true">
                    <v-window-item v-for="(item, i) in NOTARIA.Testimonios" :key="'window-' + (item.id || i) + '-' + i" role="tab">
                        <v-card >
                        <v-card-text>
                            <div class="inner">
                            <p class="textTestimonios">
                                {{ item.Descripcion }}
                            </p>
                            </div>
                            <div class="author-info">
                                    <span class="textTestimonios">{{ item.Nombre }}</span> -
                                    <span v-for="star in (item.Estrellas || 5)" :key="'star-' + (item.id || i) + '-' + star">
                                    <v-icon>
                                        {{NOTARIA.Theme.Home.Testimonios.Icon || 'mdi-star'}}
                                    </v-icon>
                                    </span>
                            </div>
                        </v-card-text>
                        </v-card>
                    </v-window-item>
                    </v-window>
                    <!-- End .v-tabs-items -->
                    <div class="d-flex justify-center w-100 mt-4">
                        <v-tabs v-model="tab" align-tabs="center" centered center-active :show-arrows="false" class="testimonial-tabs" hide-slider>                  
                            <v-tab v-for="(item, i) in NOTARIA.Testimonios" :key="'tab-' + (item.id || i) + '-' + i" role="tab">
                                <div class="thumb" v-if="item.Imagen">
                                <img :alt="'Avatar de ' + item.Nombre" :src="imagenIDtoSRC(item.Imagen)" width="60" height="60" referrerpolicy="no-referrer" />
                                </div>
                                <div class="thumb" v-else>
                                <img :alt="'Avatar de ' + item.Nombre" :src="imagenIDtoSRC(NOTARIA.Theme.Menu.Logo)"  width="60" height="60" referrerpolicy="no-referrer" />
                                </div>
                            </v-tab>
                        </v-tabs>
                    </div>
                </client-only>
                <!-- End .v-tabs -->
            </div>
            <!-- End .rn-testimonial-content -->
            </v-col>
        </v-row>
        <v-row v-if="NOTARIA.Theme.Home.Testimonios.Boton && NOTARIA.Theme.Home.Testimonios.Boton.Mostrar">
            <v-col cols="12" class="d-flex justify-center mt-8">
                <v-btn
                    :style="botonStyle"
                    class="rn-btn"
                    :href="NOTARIA.Theme.Home.Testimonios.Boton.Url"
                    target="_blank"
                >
                    {{ NOTARIA.Theme.Home.Testimonios.Boton.Texto }}
                </v-btn>
            </v-col>
        </v-row>
    </v-container>
</div>
</template>

<script setup>
import { computed, ref, onMounted, onUnmounted, watch } from 'vue'
import { storeToRefs } from 'pinia'
import {useStore} from '../../store/index.ts'
const store = useStore()
const {NOTARIA} = storeToRefs(store)
import { useUtils } from '#imports';
const {imagenIDtoSRC,$t}=useUtils()
const tab = ref(0)
let sliderInterval = null

// Vigilamos si cambian los testimonios para resetear el slider si es necesario
watch(() => NOTARIA.value?.Testimonios, (newVal) => {
  if (newVal && tab.value >= newVal.length) {
    tab.value = 0;
  }
}, { deep: true });

onMounted(() => {
  tab.value = 0; // Asegurar que empezamos en el primero
  if (sliderInterval) clearInterval(sliderInterval); 

  sliderInterval = setInterval(() => {
    if (NOTARIA.value?.Testimonios?.length > 1) {
      tab.value = (tab.value + 1) % NOTARIA.value.Testimonios.length;
    }
  }, 5000);
})

onUnmounted(() => {
  if (sliderInterval) {
    clearInterval(sliderInterval);
    sliderInterval = null;
  }
})

import { useStyles } from '../../store/styles'
const style = useStyles();

const estiloTextoColor = style.ThemeHomeTestimonios?.css?.Color ? style.ThemeHomeTestimonios?.css?.Color : ""
const estiloTextoShadow = style.ThemeHomeTestimonios?.css?.BackgroundColor ? "4px 2px 6px "+style.ThemeHomeTestimonios.css.BackgroundColor:""
const estiloTextoFont = style.ThemeHomeTestimonios?.css?.Font ? style.ThemeHomeTestimonios?.css?.Font : ""
const estiloTextoSize = style.ThemeHomeTestimonios?.css?.Size ? style.ThemeHomeTestimonios?.css?.Size : ""
const estiloTextoWeight = style.ThemeHomeTestimonios?.css?.Weight ? style.ThemeHomeTestimonios?.css?.Weight : ""
const estiloTextoAlign = style.ThemeHomeTestimonios?.css?.Align ? style.ThemeHomeTestimonios.css.Align : ""

const botonStyle = computed(() => {
  const css = NOTARIA.value?.Theme?.Home?.Testimonios?.Boton?.css
  if (!css) return {}
  return {
    color: css.Color ?? '',
    backgroundColor: css.BackgroundColor ?? '',
    fontFamily: css.Font ?? '',
    fontSize: css.Size ?? '',
    fontWeight: css.Weight ?? '',
    border: css.Color ? `1px solid ${css.Color}` : ''
  }
})
</script>
<style lang="scss">
.textTestimonios {
  color: v-bind(estiloTextoColor) !important;
  text-shadow: v-bind(estiloTextoShadow) !important;
  font-family: v-bind(estiloTextoFont) !important;
  font-size: v-bind(estiloTextoSize) !important;
  font-weight: v-bind(estiloTextoWeight) !important;
  text-align: v-bind(estiloTextoAlign) !important;
}
.testimonial-tabs .v-slide-group__prev, .testimonial-tabs .v-slide-group__next {
 display: none !important;
}
.testimonial-tabs, 
.testimonial-tabs .v-tabs-bar, 
.testimonial-tabs .v-tabs-bar__content, 
.testimonial-tabs .v-slide-group, 
.testimonial-tabs .v-slide-group__wrapper {
  height: 120px !important;
  overflow: visible !important;
}
.testimonial-tabs .v-slide-group__content {
  height: 120px !important;
  overflow: visible !important;
  display: flex !important;
  justify-content: center !important;
  flex-wrap: nowrap !important;
}

.testimonial-tabs .v-tab {
  height: 120px !important;
  min-width: 80px !important;
  padding: 0 10px !important;
  opacity: 0.4;
  transition: all 0.3s ease;
  overflow: visible !important;
}
.testimonial-tabs .v-tab--active, 
.testimonial-tabs .v-tab--selected {
  opacity: 1 !important;
}
.testimonial-tabs .thumb {
  overflow: visible !important;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100%;
}
.testimonial-tabs .thumb img {
  border: 2px solid transparent;
  border-radius: 50%;
  padding: 2px;
  filter: grayscale(100%);
  transition: all 0.3s ease;
  max-width: none !important;
  width: 60px;
  height: 60px;
}
.testimonial-tabs .v-tab--active .thumb img,
.testimonial-tabs .v-tab--selected .thumb img {
  border-color: v-bind(estiloTextoColor);
  transform: scale(1.2);
  filter: grayscale(0%) !important;
}
.testimonial-notin .v-window {
  overflow: hidden;
  margin-bottom: 20px;
}
</style>